import { createBrowserRouter } from 'react-router-dom';
import Root from '../components/Root';
import NotFound from '../routes/Error/NotFound';
import Home from '../routes/Home/Home';
import orderRoutes from './orderRouter';
import productRoutes from './productRouter';
import requestRoutes from './requestRouter';
import secureRoutes from './secureRouter';
import varificationRouter from './varificationRouter';
import externalSignRouter from './externalSignRouter';
import AuthKakao from 'routes/Auth/AuthKakao';
import AuthNaver from 'routes/Auth/AuthNaver';
import ParcelContainer from 'routes/Parcel/ParcelContainer';
import RequestParcel from 'routes/Parcel/RequestParcel';
import RequestParcelExpiration from 'routes/Parcel/RequestParcelExpiration';
import RequestParcelCompleted from 'routes/Parcel/RequestParcelCompleted';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'auth/kakao',
        element: <AuthKakao />,
      },
      {
        path: 'auth/naver',
        element: <AuthNaver />,
      },
      ...varificationRouter,
      ...requestRoutes,
      ...secureRoutes,
      ...orderRoutes,
      ...productRoutes,
      ...externalSignRouter,
    ],
    errorElement: <NotFound />,
  },
  {
    path: '/requestparcel',
    element: <ParcelContainer />,
    children: [
      {
        path: '',
        element: <RequestParcel />,
      },
      {
        path: 'expiration',
        element: <RequestParcelExpiration />,
      },
      {
        path: 'completed',
        element: <RequestParcelCompleted />,
      },
    ],
    errorElement: <NotFound />,
  },
]);

export default router;
